var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownPoint = function SvgArrowDownPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67 13.298a.426.426 0 0 0 .144.149.354.354 0 0 0 .371 0 .426.426 0 0 0 .143-.149l3.6-6.066a.531.531 0 0 0 .026-.482.445.445 0 0 0-.147-.183.358.358 0 0 0-.207-.067H6.4a.36.36 0 0 0-.207.068.446.446 0 0 0-.147.183.533.533 0 0 0 .024.481l3.6 6.066Z",
    fill: "#666"
  })));
};
export default SvgArrowDownPoint;